import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AtlasService } from '../atlas.service';
import { CommonModule } from '@angular/common';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';
// import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-atlas-hero-panel',
  templateUrl: './atlas-hero-panel.component.html',
  styleUrls: ['./atlas-hero-panel.component.scss'],
  imports: [CommonModule, ToHtmlPipe, TalkToSalesButtonComponent],
})
export class AtlasHeroPanelComponent implements OnInit, OnDestroy {
  @ViewChild('registerLink') registerLink: any;
  
  subscriptions = new Array<any>();
  heroData: any;
  constructor(private atlasPageService: AtlasService) {
    this.subscriptions = [];
  }
  isModalOpen = false;
  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  ngOnInit(): void {
    this.atlasPageService.hero$.subscribe(data => {
      if (data) {
        this.heroData = data.fields;
      }
    });
  }
  openRegisterLink(event:any, target?:string) {
    event.preventDefault();
    const link = this.registerLink.nativeElement.href;
    const searchParams = location.search !== '' ? location.search.slice(1) : '';
    let linkHasParams = new URLSearchParams(link) as any;
    let url = link;
    if(searchParams !== ''){
      if(linkHasParams.search > 0){
        url = `${link}&${searchParams}`;
      }else{
        url = `${link}?${searchParams}`;
      }
    }
    window.open(url, target || '_blank');
  }
}
